var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.btnImg)?_c('div',{staticClass:"setup-button",style:({
    width: _vm.width,
    height: _vm.height,
    fontSize: _vm.fontSize,
    fontColor: _vm.color,
    backgroundImage: 'url(' + _vm.btnImg + ')'
  }),on:{"click":_vm.setup}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }